<template>
    <div class="wrapper">
        <div class="main">
            <page-header/>
            <div class="section">
                <div class="container">
                    <div class="col-md-5 mx-auto">
                        <form @submit.prevent="register" autocomplete="off">
                            <card type="login" plain>
                                <div slot="header" class="logo-container">
                                    <h2>註冊</h2>
                                </div>

                                <fg-input class="no-border input-lg"
                                          addon-left-icon="now-ui-icons users_circle-08"
                                          placeholder="手機"
                                          autocomplete="off"
                                          v-model="form.cellphone"
                                >
                                </fg-input>

                                <button
                                        type="button"
                                        class="btn btn-outline-info btn-round btn-block"
                                        @click.prevent="getRequest"
                                        :disabled="seconds !== 0"
                                >
                                    <template v-if="seconds === 0">取得驗證碼</template>
                                    <template v-else>簡訊已發送 重新發送 ({{ seconds }})</template>
                                </button>

                                <fg-input class="no-border input-lg"
                                          addon-left-icon="now-ui-icons ui-1_email-85"
                                          placeholder="輸入驗證碼"
                                          autocomplete="off"
                                          v-model="form.verification_code"
                                >
                                </fg-input>
                                <fg-input class="no-border input-lg"
                                          addon-left-icon="now-ui-icons text_caps-small"
                                          placeholder="名稱"
                                          autocomplete="off"
                                          v-model="form.name"
                                >
                                </fg-input>
                                <fg-input class="no-border input-lg"
                                          type="password"
                                          addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                                          placeholder="密碼"
                                          autocomplete="off"
                                          v-model="form.password"
                                >
                                </fg-input>
                                <template slot="raw-content">
                                    <div class="card-footer text-center">
                                        <button type="submit" class="btn btn-outline-info btn-round btn-block">註冊</button>
                                    </div>
                                    <div class="pull-left">
                                        <h6>
                                            已經有一個帳戶？
                                            <router-link :to="{name: 'Login'}" class="ml-2 link footer-link">登入
                                            </router-link>
                                        </h6>
                                    </div>
                                </template>
                            </card>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Card, Button, FormGroupInput} from '@/components';
    import PageHeader from "@/views/partials/PageHeader";
    import {RegisterService} from "@/services/rest/register";
    import {alertSuccess, alertError} from '@/helper/alert_helper';

    const resendTime = 60; // seconds

    export default {
        name: "LoginPage",
        components: {
            PageHeader,
            Card,
            [Button.name]: Button,
            [FormGroupInput.name]: FormGroupInput
        },
        data() {
            return {
                interval: null,
                isLoading: false,
                seconds: 0,
                form: {
                    cellphone: '',
                    verification_code: '',
                    name: '',
                    password: '',
                }
            }
        },
        methods: {
            resend() {
                this.interval = setInterval(() => {
                    if(--this.seconds <= 0) {
                        clearInterval(this.interval);
                        this.seconds = 0;
                    }
                }, 1000)

                this.seconds = resendTime;
            },
            async getRequest() {
                try {
                    await new RegisterService().request(this.form);

                    this.resend();
                } catch (err) {
                    alertError(err);
                }
            },
            async register() {
                try {
                    await new RegisterService().register(this.form);

                    alertSuccess({
                        text: '註冊成功',
                    })

                    this.$router.push({name: 'Login'});
                } catch (err) {
                    alertError(err);
                } finally {
                    this.seconds = 0;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .card-login {
        border-radius: 0.25rem;
        padding-bottom: 0.7rem;
        max-width: 320px;
    }

    .section {
        text-align: center;
    }
</style>